<template>
  <button
    type="button"
    class="wechat-copy"
    data-site-entry="wechat"
    @click="copy"
    aria-live="polite"
  >
    {{ label }}
  </button>
</template>

<script>
import { profile } from "@/assets/js/profile";
import { trackSiteEvent } from "@/utils/site-analytics";

export default {
  name: "WechatCopy",
  data() {
    return { label: "复制微信号", timer: null };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    async copy() {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(profile.wechat);
        } else {
          const input = document.createElement("textarea");
          input.value = profile.wechat;
          input.style.position = "fixed";
          input.style.opacity = "0";
          document.body.appendChild(input);
          try {
            input.select();
            if (!document.execCommand("copy")) throw new Error("copy");
          } finally {
            input.remove();
          }
        }
        this.label = "已复制微信号";
        trackSiteEvent("contact_click", "wechat");
      } catch (e) {
        this.label = "复制失败，请手动复制";
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.label = "复制微信号";
      }, 2500);
    }
  }
};
</script>

<style scoped>
.wechat-copy {
  padding: 7px 12px;
  margin: 12px 0;
  color: var(--accent);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 6px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.wechat-copy:hover {
  border-color: var(--accent);
}
</style>
